<h2 mat-dialog-title>Create Broadcast Message</h2>

<mat-dialog-content>
    <!-- Target Selection -->
    <div class="target-selection-section">
        <label class="section-label">Select Target Audience</label>

        <!-- Checkboxes for target types -->
        <div class="checkbox-group">
            <mat-checkbox [checked]="selectedTargetType === 'department'" (change)="onTargetTypeChange('department')"
                color="primary">
                Department
            </mat-checkbox>

            <mat-checkbox [checked]="selectedTargetType === 'branch'" (change)="onTargetTypeChange('branch')"
                color="primary">
                Branch
            </mat-checkbox>

            <mat-checkbox [checked]="selectedTargetType === 'user'" (change)="onTargetTypeChange('user')"
                color="primary">
                User
            </mat-checkbox>

            <mat-checkbox [checked]="selectedTargetType === 'everyone'" (change)="onTargetTypeChange('everyone')"
                color="primary">
                Everyone
            </mat-checkbox>
        </div>

        <!-- Department Dropdown -->
        <mat-form-field appearance="outline" class="full-width" *ngIf="selectedTargetType === 'department'">
            <mat-label>Department</mat-label>
            <input type="text" placeholder="Search Department" matInput [formControl]="departmentCtrl"
                [matAutocomplete]="autoDept" />
            <mat-autocomplete #autoDept="matAutocomplete" autoActiveFirstOption>
                <mat-option [value]="null">-- None --</mat-option>
                <mat-option *ngFor="let department of filteredDepartments" [value]="department.departmentName">
                    {{ department.departmentName }}
                </mat-option>
            </mat-autocomplete>
            <button mat-icon-button matSuffix tabindex="-1">
                <mat-icon>arrow_drop_down</mat-icon>
            </button>
        </mat-form-field>

        <!-- Branch Dropdown -->
        <mat-form-field appearance="outline" class="full-width" *ngIf="selectedTargetType === 'branch'">
            <mat-label>Branch</mat-label>
            <input type="text" placeholder="Search Branch" matInput [formControl]="branchCtrl"
                [matAutocomplete]="autoBranch" />
            <mat-autocomplete #autoBranch="matAutocomplete" autoActiveFirstOption>
                <mat-option [value]="null">-- None --</mat-option>
                <mat-option *ngFor="let branch of filteredBranches" [value]="branch.Name">
                    {{ branch.Name }}
                </mat-option>
            </mat-autocomplete>
            <button mat-icon-button matSuffix tabindex="-1">
                <mat-icon>arrow_drop_down</mat-icon>
            </button>
        </mat-form-field>

        <!-- User Dropdown -->
        <mat-form-field appearance="outline" class="full-width" *ngIf="selectedTargetType === 'user'">
            <mat-label>Employee</mat-label>
            <input type="text" matInput [matAutocomplete]="autoEmployee" [formControl]="employeeCtrl"
                matTooltip="Employee" required>
            <mat-autocomplete #autoEmployee="matAutocomplete" autoActiveFirstOption>
                <mat-option [value]="''">-- None --</mat-option>
                <mat-option *ngFor="let employee of filteredEmployee" [value]="employee.employeeName">
                    {{ employee.employeeName }}
                </mat-option>
            </mat-autocomplete>
            <button mat-icon-button matSuffix tabindex="-1">
                <mat-icon>arrow_drop_down</mat-icon>
            </button>
        </mat-form-field>
    </div>

    <!-- Message Textarea -->
    <div class="message-section">
        <mat-form-field appearance="outline" class="full-width">
            <mat-label>Message</mat-label>
            <textarea matInput [(ngModel)]="messageContent" rows="6" placeholder="Enter your broadcast message here..."
                maxlength="500"></textarea>
            <mat-hint align="end">{{messageContent.length}} / 500</mat-hint>
        </mat-form-field>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()">Cancel</button>
    <button mat-raised-button color="primary" (click)="onSend()" *ngIf="!isLoading; else loadingTemplate"
        [disabled]="!isFormValid()">
        Send Message
    </button>
    <ng-template #loadingTemplate>
        <button mat-raised-button color="primary" cdkFocusInitial disabled>
            Send Message <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        </button>
    </ng-template>
</mat-dialog-actions>